<template>
    <div class="public_container m_message_detail_wrap" v-loading="loading">
        <div class="returnNavBar">
            <div class="returnNavBarLeft">
                <van-icon @click="handleClickReturnRouter" name="arrow-left" />
                <span class="m_message_count" v-if="category_count">{{ category_count }}</span>
            </div>
        </div>
        <div class="mobile_container" ref="scrollTarget">
            <van-pull-refresh @refresh="onPullRefreshList" success-text="刷新成功" v-model="pullLoading">
                <van-list
                    :immediate-check="false"
                    :finished="finishedList"
                    @load="onLoadList"
                    finished-text="——没有更多了——"
                    v-model="listLoading"
                    :offset="30"
                >
                    <!-- msg_notice_type: 0: 默认值或未定义,1: 仅通知，无需查看详情,2: 通知 + 点击详情跳转,3: 通知 + 点击详情跳转 + 操作 -->
                    <ul class="message_detail_wrap">
                        <li
                            class="list_item_detail"
                            :class="
                                item.msg_notice_type == 2 || item.msg_notice_type == 3
                                    ? 'list_item_bg_blue'
                                    : 'list_item_bg_green'
                            "
                            v-for="(item, index) in messageList"
                            :key="index"
                            :id="item.id"
                            :data-id="item.id"
                        >
                            <p class="list_item_detail_time">{{ item.push_time_show || "未知时间" }}</p>
                            <div class="list_item_detail_content">
                                <div class="list_item_detail_icon">
                                    <img :src="item.icon_url || icon_url" alt="" />
                                </div>
                                <div class="list_item_detail_right">
                                    <div class="list_item_detail_content_title" @click.stop="handleClickDetail(item)">
                                        <div class="flex_left">
                                            <div @dblclick.stop.prevent @click.stop.prevent>
                                                <van-checkbox
                                                    v-model="item.checked"
                                                    shape="square"
                                                    @change="handleClickOperator('complete', item)"
                                                    v-if="item.state == 'later'"
                                                ></van-checkbox>
                                            </div>
                                            <span>{{ item.title }}</span>
                                        </div>
                                        <van-icon name="arrow" v-if="item.isOperate" />
                                    </div>
                                    <div
                                        class="list_item_detail_content_bottom"
                                        @touchstart="onTouchStart($event, item)"
                                        @touchmove="onTouchMove($event)"
                                        @touchend="onTouchEnd"
                                    >
                                        <template v-if="item.content && item.content.content">
                                            <p class="txt ellipsis_text_line9">
                                                {{ item.content.content}}
                                            </p>
                                        </template>
                                        <template v-if="item.content && item.content.overview_fields && item.content.overview_fields.length">
                                            <div class="ellpsis_line9">
                                                <p v-for="(field,fieldIndex) in item.content.overview_fields" :key="fieldIndex" class="txt ellipsis_text_line9">
                                                    {{field.field_name}}：<span>{{ field.field_value }}</span>
                                                </p>
                                            </div>
                                        </template>
                                        <!-- 按钮 -->
                                        <template>
                                            <div class="list_item_btns" v-if="item.extend && item.extend.type == 'inviteUserEditToUser'">
                                                <van-button plain type="info" @click="handleClickItemOperate(item)" v-if="item.extend.button_status"
                                                    >去完善</van-button
                                                >
                                                <van-button plain disabled v-if="!item.extend.button_status">已完善</van-button>
                                            </div>
                                            <!-- <div class="list_item_btns">
                                                <template v-if="item.approvalType == 1">
                                                    <van-button plain type="info">同意</van-button>
                                                    <van-button plain type="danger">拒绝</van-button>
                                                </template>
                                                <template v-if="item.approvalType == 2">
                                                    <van-button plain type="info">确认</van-button>
                                                </template>
                                            </div> -->
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </van-list>
            </van-pull-refresh>
        </div>
        <div class="new_count_box" v-if="messageListCount > 0 && group_type == 'unread'" @click="handleClickToTop">
            <img src="https://download.hecoos.com/enlightv/2024-45/5dcd224158f9ca176d74045d01d456e8.png" alt="" />
            <span>{{ messageListCount > 99 ? "99+" : messageListCount }}条新消息</span>
        </div>
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            v-if="showActionSheet"
            :show="showActionSheet"
            @click="showActionSheet = false"
        >
            <div class="operator_dialog_wrap" v-if="showActionSheet">
                <div class="operator_item_detail_wrap">
                    <ul>
                        <li
                            v-for="(item, index) in operatorItemInfo"
                            :key="index"
                            class="list_item_detail list_item_bg_blue"
                        >
                            <div class="list_item_detail_content">
                                <div class="list_item_detail_icon">
                                    <img :src="item.icon_url || icon_url" alt="" />
                                </div>
                                <div class="list_item_detail_right">
                                    <div class="list_item_detail_content_title">
                                        <div class="flex_left">
                                            <van-checkbox
                                                v-model="item.checked"
                                                shape="square"
                                                @change="handleClickOperator('complete', item)"
                                                v-if="item.state == 'later'"
                                            ></van-checkbox>
                                            <span>{{ item.title }}</span>
                                        </div>
                                        <van-icon name="arrow" v-if="item.isOperate" />
                                    </div>
                                    <div class="list_item_detail_content_bottom">
                                        <template v-if="item.content && item.content.content">
                                            <p class="txt ellipsis_text_line9">
                                                {{ item.content.content}}
                                            </p>
                                        </template>
                                        <template v-if="item.content && item.content.overview_fields && item.content.overview_fields.length">
                                            <div class="ellpsis_line9">
                                                <p v-for="(field,fieldIndex) in item.content.overview_fields" :key="fieldIndex" class="txt ellipsis_text_line9">
                                                    {{field.field_name}}：<span>{{ field.field_value }}</span>
                                                </p>
                                            </div>
                                        </template>
                                        <!-- 按钮 -->
                                        <template>
                                            <div class="list_item_btns" v-if="item.extend && item.extend.type == 'inviteUserEditToUser'">
                                                <van-button plain type="info" @click="handleClickItemOperate(item)" v-if="item.extend.button_status"
                                                    >去完善</van-button
                                                >
                                                <van-button plain disabled v-if="!item.extend.button_status">已完善</van-button>
                                            </div>
                                            <!-- <div class="list_item_btns">
                                                <template v-if="item && item.approvalType == 1">
                                                    <van-button plain type="info">同意</van-button>
                                                    <van-button plain type="danger">拒绝</van-button>
                                                </template>
                                                <template v-if="item && item.approvalType == 2">
                                                    <van-button plain type="info">确认</van-button>
                                                </template>
                                            </div> -->
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="operator_item_box">
                    <ul>
                        <li
                            v-if="!currentOperatorItem.is_closed"
                            @click.stop="handleClickOperator('disturb', currentOperatorItem)"
                        >
                            <span>此类消息免打扰</span>
                            <i class="iconfont icon-message-notification"></i>
                        </li>
                        <li
                            v-if="currentOperatorItem.is_closed"
                            @click.stop="handleClickOperator('open', currentOperatorItem)"
                        >
                            <span>此类消息继续推送</span>
                            <i class="iconfont icon-xiaoxi-tuisong"></i>
                        </li>
                        <li
                            v-if="
                                (currentOperatorItem.status == 'unread' || currentOperatorItem.status == 'read') &&
                                currentOperatorItem.msg_notice_type == 3
                            "
                            @click.stop="handleClickOperator('later', currentOperatorItem)"
                        >
                            <span>稍后处理</span>
                            <i class="iconfont icon-messgae-clock"></i>
                        </li>
                    </ul>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import {
    CategoryMessages,
    MessageBatchMarkRead,
    MessageBatchMarkLater,
    MessageBatchMarkComplete,
    MessageSettingSwitch,
    getUserDetail
} from "@/api";
import { EventBus } from '@/utils/eventBus';
export default {
    name: "MMessageDetail",
    data() {
        return {
            category_count: this.$route.query && this.$route.query.count,
            group_type: this.$route.query && this.$route.query.group_type,
            category_name_en: this.$route.query && this.$route.query.category_name_en,

            icon_url: "",
            loading: false,
            start_id: "",
            end_id: "",
            orderType: "desc",
            pullLoading: false,
            listLoading: false,
            pullFinishedList: false, // 主要处理是否还可以下拉
            finishedList: false, // 主要处理是否还可以上拉加载
            messageListLoading: false,
            messageList: [],

            messageListCount: 0,
            scrollIconMinId: "", // 最小ID，用于页面跳转到最顶部的时候使用
            toucheX: 0,
            toucheY: 0,
            timeOutEvent: "",
            showActionSheet: false,
            // 长按操作 当前的数据
            operatorItemInfo: [],
            currentOperatorItem: {},
        };
    },
    created() {
        if (this.category_name_en) {
            this.initCategoryMessages();
        }
    },
    mounted() {},
    methods: {
        handleClickReturnRouter() {
            if (this.$router.history.length <= 1) {
                // 没有上一页，跳转到固定页面
                this.$router.push({ name: "mobileAllFunctions" });
            } else {
                // 有上一页，后退
                EventBus.$emit("messageUpdate")
                this.$router.go(-1);
            }
        },
        // 初始化列表滚动到最底部
        initContainerToBottom() {
            this.$nextTick(() => {
                let scrollableElement = document.querySelector(".mobile_container");
                scrollableElement.scrollTop = scrollableElement.scrollHeight - scrollableElement.clientHeight;

                setTimeout(() => {
                    const elementArray = document.querySelector(".message_detail_wrap").children;
                    this.createIntersectionObserver(elementArray, this.changeCheck);
                }, 400);
            });
        },
        //监听元素是否进入可视区域
        createIntersectionObserver(elementArray, callback) {
            // 创建JS交叉观察函数
            const container = document.querySelector(".mobile_container");

            // 创建IntersectionObserver实例，并指定根元素为container
            const options = {
                root: container, // 指定根元素为container
                rootMargin: "0px", // 根元素的外边距，这里设置为0px
                threshold: 0.5, // 交叉比例的阈值，这里设置为0.5，即目标元素50%可见时触发回调
            };

            this.observer = new IntersectionObserver((mutaions) => {
                // 创建IntersectionObserver对象 出现在视口里了
                mutaions.forEach((entry) => {
                    if (entry.isIntersecting) {
                        callback(entry.target.id);
                    }
                });
                if (mutaions[0].isIntersecting) {
                    // 传入参数并调用回调函数
                    callback(mutaions[0].target.id);
                }
            }, options);
            for (let i = 0; i < elementArray.length; i++) {
                // 需要监听的元素
                this.observer.observe(elementArray[i]);
            }
        },
        changeCheck(id) {
            let res = this.messageList.filter((p) => p.id == id)?.[0] || null;
            if (res && res.status == "unread") {
                // console.log(res, 'res====')
                // 手动改为已读, 不刷新列表
                this.$set(res, "status", "read");
                this.setMessageBatchMarkRead([res.id]);
                // this.messageListCount--;
            }
        },
        // 跳转到最顶端
        handleClickToTop() {
            if (this.scrollIconMinId == this.messageList[0].id) {
                // 当前的列表已包含所有的未读数据，不需要去请求接口了
                let scrollableElement = document.querySelector(".mobile_container");
                scrollableElement.scrollTop = 0;
                this.$nextTick(() => {
                    this.messageListCount = 0;
                });
            } else {
                // 去拿更多的没有读取的未读消息
                this.start_id = this.scrollIconMinId;
                this.end_id = "";
                this.orderType = "desc";
                this.getCategoryMessages();
            }
        },
        // 长按弹出上拉操作面板
        onTouchStart(e, item) {
            if (item) {
                this.currentOperatorItem = item;
                this.operatorItemInfo = [item];
            }
            this.toucheX = e.targetTouches[0].screenX;
            this.toucheY = e.targetTouches[0].screenY;
            // 开启定时器前先清除定时器，防止重复触发
            this.timeOutEvent && clearTimeout(this.timeOutEvent); // 显示上拉面板
            this.timeOutEvent = setTimeout(() => {
                this.showActionSheet = true;
            }, 500);
            // e.preventDefault(); // 阻止系统默认事件
        },
        // 长按
        onTouchMove(e) {
            const moveX = e.targetTouches[0].screenX;
            const moveY = e.targetTouches[0].screenY;
            // 解决vivo机型，手指没有move，touchmove事件仍然会调用而导致setTimeout被clear
            if (this.toucheX !== moveX || this.toucheY !== moveY) {
                // 手指滑动，清除定时器，中断长按逻辑

                this.timeOutEvent && clearTimeout(this.timeOutEvent);
            }
        },
        // 长按结束
        onTouchEnd() {
            // 清除定时器，结束长按逻辑
            this.timeOutEvent && clearTimeout(this.timeOutEvent); // 若手指离开屏幕，时间小于我们设置的长按时间，则为点击事件
        },
        // 因为既要查看详情，又要有长按事件，所以给内容区域添加了长按事件，给标题添加了查看详情事件
        handleClickDetail(item) {
            if(item.link) {
                if(this.category_name_en === 'hr_notice'){
                    // 人事
                    const link_data = item.link.split("?")
                    const id = link_data[1] && link_data[1].split("=") && link_data[1].split("=")[1]
                    if(id) {
                        // 处理跳转路径，因为配置的路径在移动端不能用，所以要处理下
                        getUserDetail({
                            user_id: id,
                        }).then((res) => {
                            if (res.code === 200) {
                                const row = res.data;
                                if (row.quit_info && row.quit_info.quit_status == 0) {
                                    // 待离职
                                    this.$router.push({
                                        name: "MLeaveOfficeDetail",
                                        query: {
                                            uid: row.user_id,
                                            id: row.quit_info.id,
                                        },
                                    });
                                } else {
                                    this.$router.push({
                                        name: "MPersonnelDetail",
                                        query: {
                                            uid: row.user_id,
                                        },
                                    });
                                }
                            }
                        })

                    } else {
                        this.$router.push({
                            path: item.link
                        })
                    }
                } else {
                    this.$router.push({
                        path: item.link
                    })
                }
            }
        },
        // 每一项的按钮操作
        handleClickItemOperate(item) {
            console.log("按钮");
        },
        handleClickOperator(type, item) {
            switch (type) {
                case "disturb":
                    this.handleSwitchChange(item);
                    break;
                case "later":
                    this.setMessageBatchMarkLater([item.id]);
                    break;
                case "open":
                    this.handleSwitchChange(item);
                    break;
                case "complete":
                    this.setMessageBatchMarkComplete([item.id]);
                    break;
            }
        },
        // 标记消息已读
        setMessageBatchMarkRead(ids) {
            const params = {
                message_record_user_ids: ids,
            };
            MessageBatchMarkRead(params).then((res) => {
                if (res.code === 200) {
                    // this.initCategoryMessages();
                }
            });
        },
        // 标记消息稍后处理
        setMessageBatchMarkLater(ids) {
            const params = {
                message_record_user_ids: ids,
            };
            MessageBatchMarkLater(params).then((res) => {
                if (res.code === 200) {
                    this.$toast("已添加至稍后处理分组");
                    this.initCategoryMessages();
                    this.showActionSheet = false;
                    this.operatorItemInfo = [];
                    this.currentOperatorItem = {};
                }
            });
        },
        // 标记消息已完成
        setMessageBatchMarkComplete(ids) {
            const params = {
                message_record_user_ids: ids,
            };
            MessageBatchMarkComplete(params).then((res) => {
                if (res.code === 200) {
                    this.$toast("已完成");
                    this.initCategoryMessages();
                    this.showActionSheet = false;
                    this.operatorItemInfo = [];
                    this.currentOperatorItem = {};
                }
            });
        },
        // 标记消息模版开启关闭免打扰
        handleSwitchChange(item) {
            const params = {
                template_id: item.template_id,
                status: !item.is_closed, //是否开启免打扰 开启true 关闭false
            };
            MessageSettingSwitch(params).then((res) => {
                if (res.code === 200) {
                    if (item.is_closed) {
                        this.$toast("消息提醒已开启");
                    } else {
                        this.$toast("已移入免打扰分组");
                    }
                    this.initCategoryMessages();
                    this.showActionSheet = false;
                    this.operatorItemInfo = [];
                    this.currentOperatorItem = {};
                }
            });
        },
        // 初始化消息列表数据
        initCategoryMessages() {
            this.messageList = [];
            this.start_id = "";
            this.end_id = "";
            this.orderType = "desc";
            this.finishedList = false;
            this.pullFinishedList = false;
            this.$nextTick(() => {
                this.getCategoryMessages();
            });
        },
        // 下拉
        onPullRefreshList() {
            console.log("下拉");
            if (!this.category_name_en) return;
            this.start_id = this.messageList.length ? this.messageList[0].id : "";
            this.end_id = "";
            this.orderType = "desc";
            this.getCategoryMessages();
        },
        onLoadList() {
            console.log("上拉");
            if (!this.category_name_en) return;
            this.start_id = "";
            this.end_id = this.messageList.length ? this.messageList[this.messageList.length - 1].id : "";
            this.orderType = "asc";
            this.getCategoryMessages();
        },
        // 获取消息列表
        getCategoryMessages() {
            if (!this.category_name_en) return;
            if ((this.finishedList && this.end_id) || (this.pullFinishedList && this.start_id)) {
                this.pullLoading = this.listLoading = false;
                return false;
            };
            if (this.end_id) {
                this.finishedList = true;
            }
            if (this.start_id) {
                this.pullFinishedList = true;
            }
            this.messageListLoading = true;
            let params = {
                group_type: this.group_type,
                category_name_en: this.category_name_en,
                order: this.orderType,
                limit: 10,
            };
            if (this.start_id || this.end_id) {
                params.start_id = this.start_id || this.end_id;
            }
            CategoryMessages(params)
                .then((res) => {
                    if (res.code === 200) {
                        const { list_data, icon_url, show_count_data, min_id } = res.data;
                        this.icon_url = icon_url;
                        if (!this.start_id && !this.end_id) {
                            // 刚初始化数据的时候是没有开始和结束id的
                            const data = list_data.reverse();
                            this.messageList = data;
                            this.initContainerToBottom();
                        } else {
                            if (this.orderType == "desc") {
                                // 降序排列
                                // 往上滑动
                                const data = list_data.reverse();
                                this.messageList = data.concat(this.messageList);
                            } else {
                                this.messageList = this.messageList.concat(data);
                            }
                        }
                        // 在未读的消息列表里展示滚动到顶部的图标
                        if (this.group_type == "unread") {
                            if (this.orderType == "desc") {
                                if (show_count_data > 5) {
                                    // 先写死一个数，用于判断一屏幕显示的条数，如果大于这个条数页面才需要展示消息图标
                                    this.messageListCount = show_count_data;
                                    this.scrollIconMinId = min_id;
                                } else {
                                    this.messageListCount = 0;
                                    this.scrollIconMinId = "";
                                }
                            } else {
                                if(!this.scrollIconMinId) {
                                    this.messageListCount = 0;
                                    this.scrollIconMinId = "";
                                }
                            }
                        }

                        if (this.end_id || (!this.start_id && !this.end_id)) {
                            this.finishedList = list_data.length === 0; //上滑列表加载完了所有数据（没有更多了）
                            // console.log(this.finishedList, "finishedList===");
                        }
                        if (this.start_id) {
                            this.pullLoading = this.listLoading = false; // 加载和下拉状态结束
                            this.pullFinishedList = list_data.length === 0; //下拉列表加载完了所有数据（没有更多了）
                            if (list_data.length === 0) {
                                this.messageListCount = 0;
                            }
                        }
                    }
                    this.messageListLoading = false;
                })
                .catch(() => {
                    this.messageListLoading = false;
                });
        },
    },
    beforeDestroy() {
        //销毁前取消监听
        this.observer && this.observer.disconnect();
    },
};
</script>

<style lang="scss" scoped>
.m_message_detail_wrap {
    position: relative;
}
.returnNavBar {
    .m_message_count {
        min-width: 18px;
        height: 18px;
        line-height: 16px;
        text-align: center;
        border: 1px solid #ffffff;
        font-size: 10px;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
        border-radius: 10px;
        background-color: rgba(0, 0, 0, 0.04);
    }
}
.mobile_container {
    background-color: #ffffff;
    ul {
        padding: 0 16px 0 0;
        background-color: #ffffff;
    }
}
.list_item_detail {
    padding: 0 24px 0 0;
    margin-bottom: 16px;

    .list_item_detail_time {
        padding: 0 24px 10px 50px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
        text-align: center;
    }

    .list_item_detail_content {
        display: flex;

        .list_item_detail_icon {
            flex-shrink: 0;
            width: 50px;
            padding: 0 10px;

            img {
                width: 30px;
                height: auto;
            }
        }

        .list_item_detail_right {
            flex: 1;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(227, 240, 255, 1);
            overflow: hidden;
        }

        .list_item_detail_content_title {
            min-height: 46px;
            padding: 11px 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;

            span {
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 22px;
            }

            .iconfont {
                display: none;
                cursor: pointer;
            }
            .flex_left {
                flex: 1;
                display: flex;
                align-items: center;
                overflow: hidden;
                ::v-deep {
                    .van-checkbox {
                        margin-right: 10px;
                        flex-shrink: 0;
                        .van-checkbox__icon {
                            font-size: 16px;
                            height: 16px;
                            line-height: 16px;
                            .van-icon {
                                border-color: rgba(217, 217, 217, 1);
                                border-radius: 4px;
                            }
                        }
                    }
                    .van-checkbox__icon--checked .van-icon {
                        border-color: rgba(41, 144, 255, 1) !important;
                        background-color: rgba(41, 144, 255, 1) !important;
                    }
                }
            }
        }

        .list_item_detail_content_bottom {
            padding: 10px;

            p {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
            }

            .ellipsis_text {
                display: flex;
                justify-content: space-between;
                gap: 4px;
            }

            .ellipsis {
                flex: 1;
            }

            .link_icon {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(41, 144, 255, 1);
                cursor: pointer;

                img {
                    width: 14px;
                    vertical-align: text-top;
                }
            }
            .list_item_btns {
                margin-top: 10px;
                display: flex;
                gap: 10px;
                .van-button {
                    flex: 1;
                    height: 32px;
                    line-height: 32px;
                    border-radius: 4px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    background-color: #ffffff !important;
                    &.van-button--info {
                        color: rgba(41, 144, 255, 1);
                        border-color: rgba(41, 144, 255, 1);
                    }
                    &.van-button--danger {
                        border-color: rgba(228, 65, 68, 0.8);
                        color: rgba(228, 65, 68, 0.8);
                    }
                    &:active {
                        &::before {
                            background-color: #ffffff;
                        }
                    }
                }
            }
            .ellpsis_line9 {
                max-height: 198px;
                overflow: hidden;
            }
            .ellipsis_text_line9 {
                display: -webkit-box;
                -webkit-line-clamp: 9;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .link_text {
            color: rgba(41, 144, 255, 1);
            cursor: pointer;
        }
    }

    .el-button {
        margin-top: 10px;
        padding: 4px 8px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
    }

    &.list_item_bg_blue {
        .list_item_detail_content {
            .list_item_detail_content_title {
                background-color: rgba(227, 240, 255, 1);
                color: rgba(42, 130, 228, 1);
            }
        }
    }

    &.list_item_bg_green {
        .list_item_detail_content {
            .list_item_detail_content_title {
                background-color: rgba(242, 245, 235, 1);
                color: rgba(107, 138, 76, 1);
            }
        }
    }
}
.operator_dialog_wrap {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    .operator_item_detail_wrap {
        padding: 0 16px 0 0;
    }
    .list_item_detail {
        margin-bottom: 6px;
    }
    .operator_item_box {
        padding: 0 40px 0 0;
        display: flex;
        justify-content: flex-end;
        ul {
            width: 164px;
            border-radius: 8px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
            li {
                padding: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                span {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
                .iconfont {
                    color: rgba(51, 51, 51, 1);
                    font-size: 16px;
                }
                & + li {
                    border-top: 1px solid rgba(222, 222, 222, 1);
                }
            }
        }
    }
}
.new_count_box {
    position: absolute;
    width: 119px;
    top: 74px;
    right: 0;
    height: 38px;
    border-radius: 70px 0px 0px 70px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(232, 232, 232, 1);
    box-shadow: 0px 3px 6px 2px rgba(0, 0, 0, 0.08);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    cursor: pointer;

    img {
        width: 14px;
        transform: rotateZ(180deg);
    }

    span {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(41, 144, 255, 1);
    }
}
</style>
